module.exports = __webpack_public_path__ + "img/joaquimRosa.178eb8e0.webp";